/* ----- code generated do not modify ----- */
var components_combo_box_locale7 = {
  "focusAnnouncement": function focusAnnouncement(args, formatter) {
    return "".concat(formatter.select({
      "true": function _true() {
        return "Entered group ".concat(args.groupTitle, ", with ").concat(formatter.plural(args.groupCount, {
          one: function one() {
            return "".concat(formatter.number(args.groupCount), " option");
          },
          other: function other() {
            return "".concat(formatter.number(args.groupCount), " options");
          }
        }), ". ");
      },
      other: ""
    }, args.isGroupChange)).concat(args.optionText).concat(formatter.select({
      "true": ", selected",
      other: ""
    }, args.isSelected));
  },
  "countAnnouncement": function countAnnouncement(args, formatter) {
    return "".concat(formatter.plural(args.optionCount, {
      one: function one() {
        return "".concat(formatter.number(args.optionCount), " option");
      },
      other: function other() {
        return "".concat(formatter.number(args.optionCount), " options");
      }
    }), " available.");
  },
  "selectedAnnouncement": function selectedAnnouncement(args) {
    return "".concat(args.optionText, ", selected");
  },
  "buttonLabel": "Show suggestions",
  "listboxLabel": "Suggestions"
};

export { components_combo_box_locale7 as default };
//# sourceMappingURL=en-US.esm.js.map
